<template>
    <div class="pageNotFound">
        <div class="o-page-not-found">
         <div class="c-responsive-fixwidth o-no-page-area">
                <div class="no-page-display">
                   <i class="fa fa-frown-o" aria-hidden="true"></i>
                   <br />
                    <h1>403!</h1>
                    <h5>
                        Unfortunatly something went wrong
                    </h5>
                    <div>
                        <a @click="goToJobList()" class="c-solid-btn c-solid-btn--green">BACK TO HOME</a>
                    </div>
                    
                </div>
         </div>
         </div>
    </div>
</template>

<script>
    import service from '../services';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        global
    } from '../global.js';

    export default {
        computed: {
            ...mapGetters({
                userID: 'userID',

            })
        },
        data() {
            return {

            }
        },
        methods: {
            goToJobList() {
                this.$router.push({
                    'path': '/jobList'
                });
            },
        },
        mounted() {
            //alert('created');
            //$('.pageNotFound').parent('.wrapper').css('margin-left', '0');
        },
        beforeMount() {},
        created() {

        }
    }

</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/pageNotFound.vue